

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import routelist from './router/index'

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import axios from 'axios'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

Vue.use(AjaxPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(VueRouter)
const routes = routelist.options.routes
const router = new VueRouter({
mode: 'history',
routes
})
Vue.use(router)
axios.interceptors.request.use(
config => {

config.headers['Content-Type'] = 'application/json'
let token = localStorage.getItem('users_token')
if (token) {
config.headers.common['WebAuthorization'] = localStorage.getItem('users_token')
}
return config
},
err => {
return Promise.reject(err)
}
)

axios.interceptors.response.use(res => {

res = res.data
return res
}, err => {
return Promise.reject(err)
})

/* 请求开始设置loading状态，阻止同一用户瞬间多次请求 */
axios.interceptors.request.use(config => {
store.commit('startLoading')
setTimeout(function () {
store.commit('finishLoading')
}, 30000)
return config
})
/* 请求结束取消loading状态，可以继续访问 */
axios.interceptors.response.use(config => {
store.commit('finishLoading')
return config
}, error => {
store.commit('finishLoading')
let str = error + ''
if (str.search('timeout') !== -1) { // 超时error捕获
alert('请求超时')
} else {
alert('系统或网络错误')
}
})
FastClick.attach(document.body)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js